import { API_URL } from "../../config"
import { getToken } from "../../util/validation";

const token = JSON.parse(getToken);

export async function getResellersCustomerShiviom(reseller_domain){
    try {

        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'reseller_domain': reseller_domain
        }

        const response = await fetch(API_URL + 'adminpanel/get_reseller_customer_shiviom/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {

            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }   
}